import { startCase } from 'lodash-es'
import { useSubcategoriesPhases } from '~/entities/categories'
import { RadioButton } from '~/shared/ui'
import { useFilters } from '../../../model'

export function PhaseFilter() {
  const { filters, setFilters } = useFilters()
  const subcategoriesPhases = useSubcategoriesPhases()

  return subcategoriesPhases.map((phase) => (
    <div
      key={phase}
      className="flex items-center px-2 py-0.5"
    >
      <RadioButton
        className="max-w-[255px]"
        label={startCase(phase)}
        gutter
        size="small"
        checked={filters.phase.includes(phase)}
        onChange={() => {
          setFilters({
            phase: [phase],
          })
        }}
      />
    </div>
  ))
}
